export default __webpack_public_path__ + "static/media/logo.d8276069.png";